<div class="select-button-wrapper">
  <p-selectButton [options]="options" [optionLabel]="optionLabel" [optionValue]="optionValue" [id]="id"
                  [allowEmpty]="allowEmpty" (onChange)="onInput($event)" [disabled]="formControl['disabled']">
    <ng-template let-item pTemplate>
      <span class="{{item[optionValue] === formControl.value ? 'selected' : ''}}">{{'button.' + item[optionLabel] | translate | uppercase}}</span>
    </ng-template>
  </p-selectButton>
  <app-form-input-error [show]="formControl.invalid && (formControl.dirty || formControl.touched)"
                        [required]="formControl.errors?.['required']"></app-form-input-error>
</div>
